/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css, keyframes } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';

const placaeholderOpacity = keyframes`
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
`;

export const CpdsGridPlaceholderCard = styled.div`
  ${() => {
    return css`
      padding-top: 70%;
      width: 100%;
      overflow: hidden;
      position: relative;
      background-color: #999ca8;
      &:before {
        animation: ${placaeholderOpacity} 0.75s linear infinite;
        background-color: #b1b3bd;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }
    `;
  }}
`;

const CpdsGridPlaceholderStyleTag = styled.div`
  ${({
    theme: {
      styles: { cpds },
    },
    props,
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      width: 100%;
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export { CpdsGridPlaceholderStyleTag };
